import React from 'react';
import {Select} from 'antd';

export default function CustomSelect({children, ...props}) {
    const {Option} = Select
    return (
        <Select 
        {...props}
        showSearch

        optionFilterProp="children"
    filterOption={(input, option) =>
      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    filterSort={(optionA, optionB) =>
      optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
    }
        >
            {
                children && 
                children.map (child => (
                    <Option value={child.id}
                    key={child.label}>{child.label}</Option>
                ))
            }
        </Select>
    )
}
